/**
 * Represents an account tag.
 */
export default class MoneroAccountTag {
    constructor(accountTag) {
        Object.assign(this, accountTag);
    }
    getTag() {
        return this.tag;
    }
    setTag(tag) {
        this.tag = tag;
        return this;
    }
    getLabel() {
        return this.label;
    }
    setLabel(label) {
        this.label = label;
        return this;
    }
    getAccountIndices() {
        return this.accountIndices;
    }
    setAccountIndices(accountIndices) {
        this.accountIndices = accountIndices;
        return this;
    }
}
